module.exports = __webpack_public_path__ + "img/texhnicalConfig.15e4931a.svg";